import React, { useState } from 'react';
import { motion } from 'framer-motion';
import '../assets/css/Gallery.css';

// Fotos da equipa (usadas na secção "Nossa Equipa" da Home) não devem aparecer na galeria
const TEAM_PHOTO_NAMES = [
  'Mario Piedade',
  'Elizabete Veloso',
  'Carla Campos',
  'Luisa Sousa',
  'Hildeberto Teixeira',
];

// Consome todas as imagens da pasta, exceto as que começam com 'offer' ou 'logo', ou são fotos da equipa
const importAll = (r) =>
  r.keys()
    .filter(
      (item) =>
        !item.includes('offer') &&
        !item.includes('logo') &&
        !TEAM_PHOTO_NAMES.some((name) => item.includes(name))
    )
    .map(r);

const images = importAll(require.context('../assets/img', false, /\.(jpe?g|png)$/));

const Gallery = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [currentIdx, setCurrentIdx] = useState(0);

  const openModal = idx => {
    setCurrentIdx(idx);
    setModalOpen(true);
  };
  const closeModal = () => setModalOpen(false);
  const prevImg = e => {
    e.stopPropagation();
    setCurrentIdx((prev) => (prev - 1 + images.length) % images.length);
  };
  const nextImg = e => {
    e.stopPropagation();
    setCurrentIdx((prev) => (prev + 1) % images.length);
  };

  return (
    <>
      <motion.section 
        className="hero-section-g"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, ease: "easeOut" }}
      >
        <img
          className="hero-bg-video"
          src={require('../assets/img/grad.jpg')}
          alt="Gallery background"
        />
        <div className="hero-overlay"></div>
        <div className="hero-decoration-circles">
          <div className="hero-circle hero-circle-1"></div>
          <div className="hero-circle hero-circle-2"></div>
          <div className="hero-circle hero-circle-3"></div>
          <motion.div 
            className="floating-shape shape-heart"
            animate={{ 
              y: [0, -15, 0],
              rotate: [0, 5, 0]
            }}
            transition={{
              repeat: Infinity,
              duration: 5,
              ease: "easeInOut"
            }}
          >
            <i className="bi bi-heart-fill"></i>
          </motion.div>
          <motion.div 
            className="floating-shape shape-circle"
            animate={{ 
              y: [0, 20, 0],
              x: [0, 10, 0]
            }}
            transition={{
              repeat: Infinity,
              duration: 7,
              ease: "easeInOut"
            }}
          />

        </div>

        <div className="hero-content">
          <motion.h1
            className="hero-title"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
          >
            Galeria de Fotos
          </motion.h1>
          
          <motion.p
            className="hero-description"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5, ease: "easeOut" }}
          >
            {/**
             * 
            Momentos especiais e o ambiente acolhedor do Talatona Kids
             */}
          </motion.p>

          <motion.div
            className="hero-stats-g"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8, ease: "easeOut" }}
          >
            <div className="hero-stat-item">
              <div className="stat-icon">
                <i className="bi bi-camera-fill"></i>
              </div>
              <div className="stat-number">{images.length}</div>
              <div className="stat-text">Fotos</div>
            </div>
            <div className="hero-stat-item">
              <div className="stat-icon">
                <i className="bi bi-calendar-event-fill"></i>
              </div>
              <div className="stat-number">365</div>
              <div className="stat-text">Dias de Alegria</div>
            </div>
            <div className="hero-stat-item">
              <div className="stat-icon">
                <i className="bi bi-emoji-smile-fill"></i>
              </div>
              <div className="stat-number">∞</div>
              <div className="stat-text">Sorrisos</div>
            </div>
          </motion.div>
        </div>
      </motion.section>

      <section className="section-g-container">
        <div className="container">
          <h2 className="section-g-title">Nossos Momentos</h2>
          <p className="section-g-intro">Clique nas imagens para visualizá-las em tamanho completo.</p>
          <div className="row g-4 justify-content-center">
            {images.map((src, idx) => (
              <div key={idx} className="col-6 col-md-4 col-lg-3 d-flex justify-content-center">
                <div className="gallery-img-card" onClick={() => openModal(idx)}>
                  <img className="gallery-img" src={src} alt={`Foto ${idx + 1}`} />
                </div>
              </div>
            ))}
            {images.length === 0 && (
              <div className="col-12 text-center text-muted mt-4">Adicione imagens na pasta <code>src/assets/img/</code> para expandir a galeria.</div>
            )}
          </div>
          {modalOpen && (
            <div className="modal-overlay" onClick={closeModal}>
              <div className="modal-content" onClick={e => e.stopPropagation()}>
                <button className="close-button" onClick={closeModal} title="Fechar">&times;</button>
                <button className="nav-button prev-button" onClick={prevImg} title="Anterior">&#8592;</button>
                <img className="modal-img" src={images[currentIdx]} alt={`Foto ${currentIdx + 1}`} />
                <button className="nav-button next-button" onClick={nextImg} title="Próxima">&#8594;</button>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Gallery;